export default (state = {}, action) => {
  switch (action.type) {
    case "DROP_TARGET/SET": {
      if (action.payload === null) return {};
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
